import { render, staticRenderFns } from "./ChartStatCard.vue?vue&type=template&id=0808601b&"
import script from "./ChartStatCard.vue?vue&type=script&lang=js&"
export * from "./ChartStatCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports